module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/UserLogo.075e03ff.png";